<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
                <div class="o-grid__cell u-no-p"></div>
                <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                    <button class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.cancel()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
		</div>
		<div class="c-modal__content u-no-pt">
			<p class="c-text c-text--center c-text--lg c-modal__title u-osb-lg" *ngIf="vm.title">{{ vm.title }}</p>
			<p class="c-text c-text--center u-osb-md">{{ vm.text }}</p>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid o-grid--center-h">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
					<button id="notificationModalSubmitButton" class="c-button c-button--s2 c-button--fit" (click)="vm.submit()"><span class="c-text c-text--uppercase">{{ vm.btnText }}</span></button>
				</div>
			</div>
		</div>
	</div>
</div>
